declare var Swiper;

namespace AgerLMS.WebSite {

    export interface MainPageWidgetRequest {
        homePopupActive : boolean;
    }

    @Serenity.Decorators.registerClass()
    export class MainPageWidget extends Serenity.Widget<MainPageWidgetRequest> {

        constructor(element: JQuery, opt: MainPageWidgetRequest) {
            super(element, opt);

            new Swiper('.devager-slider .swiper', {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: {
                delay: 8000,
                disableOnInteraction: false,
             },
             pagination: {
                el: '.swiper-pagination',
                clickable: true,
             },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              }
             });

             if (opt.homePopupActive) {
                Administration.PSiteSettingsService.GetMainPageSettings({}, (response) => {
                        if (response.Entity.HomePopup) {
                            window.setTimeout(function () {
                                SweetAlert.swal_warning("Önemli Uyarı!", response.Entity.HomePopup);
                            }, 10);
                        }
                    });
             }
        }
    }
}